"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBadge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DistributionRequest_1 = require("domain/DistributionRequest");
const badge_1 = require("../ui/badge");
const VARIANT = {
    [DistributionRequest_1.DistributionRequestStatus.ACCEPTED]: 'success',
    [DistributionRequest_1.DistributionRequestStatus.DUPLICATE]: 'muted',
    [DistributionRequest_1.DistributionRequestStatus.SUPERSEDED]: 'warning',
    [DistributionRequest_1.DistributionRequestStatus.INVALID]: 'destructive',
    [DistributionRequest_1.DistributionRequestStatus.SUPPRESSED]: 'warning',
};
const StatusBadge = ({ status }) => (0, jsx_runtime_1.jsx)(badge_1.Badge, { variant: VARIANT[status], children: status });
exports.StatusBadge = StatusBadge;
